<template>
  <div class="log-item" @click="displayMeta = !displayMeta" :class="{'activated-bg':displayMeta && metaFormatted}">
    <div class="log-message">
      <div class="log-meta timestamp info-fg" v-if="showTimes">{{ msg.time_fmt }}</div>
      <div class="log-meta level" :class="msg.level + '-fg'">{{ msg.level }}</div>

      <div class="log-meta tags">
        <div class="log-meta tag xsmall" v-if="msg.direction">{{ msg.direction }}</div>
        <div class="log-meta tag xsmall" v-if="msg.channel">ch:{{ msg.channel }}</div>
        <div class="log-meta tag xsmall" v-if="msg.subject">sbj:{{ msg.subject }}</div>
        <div class="log-meta tag xsmall" v-if="msg.sender">src:{{ msg.sender }}</div>
        <div class="log-meta tag xsmall" v-if="msg.type">typ:{{ msg.type }}</div>
      </div>

      <div class="log-meta message">{{ msg.message }}</div>
    </div>

    <div class="log-data" v-if="displayMeta && metaFormatted">
      <pre class="xsmall">{{metaFormatted}}</pre>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      displayMeta: false
    };
  },
  props: ['msg', 'showTimes'],
  computed: {
    metaFormatted () {
      return this.msg.meta ? JSON.stringify(this.msg.meta, null, 2) : null;
    }
  },
  mounted () {
    this.$emit('setScrollHeight');
  }
};
</script>

<style lang="scss" scoped>

  .log-item {
    display: flex;
    flex-direction: column;
    padding: 0 50px;
    display:block;

    &:last-of-type {
      //margin-bottom: 50px;
    }

    &:hover {
      background-color: #d5d4da;
      cursor: pointer;
    }
  }

  .activated-bg {
    background-color: #d5d4da;
    padding-top: 15px;
    padding-bottom: 15px;

    pre {
      padding: 20px 50px;
      line-height: 1.5em;
    }
  }

  .log-message {
    padding: 3px;
    display: flex;
    flex-direction: row;
    align-items: center;

  }

  .log-meta.tags {
    display: flex;
    flex-direction: row;
    margin-right: 5px;
  }

  .timestamp {
    width: 120px;
    flex-shrink: 0;
  }

  .log-data{
    width: 100%;
  }

  .tag {
    color: white;
    background-color: #a29999;
    flex-shrink: 0;
    padding: 3px 4px 4px 6px;
    margin-right: 5px;
    border-radius: 4px;
  }

  .direction {
    padding-right: 10px;
  }

  .level {
    width: 85px;
    flex-shrink: 0;
  }
</style>
